import { render, staticRenderFns } from "./task.invite.vue?vue&type=template&id=5f52ba2b&scoped=true"
import script from "./task.invite.vue?vue&type=script&lang=js"
export * from "./task.invite.vue?vue&type=script&lang=js"
import style0 from "./task.invite.vue?vue&type=style&index=0&id=5f52ba2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52ba2b",
  null
  
)

export default component.exports